export const DEFAULT_TONES: {
    [id: string]: { fromVerse: number; tone: string }[];
} = {
    "1": [{ fromVerse: 1, tone: "1a.1" }],
    "2": [{ fromVerse: 1, tone: "3a.4" }],
    "3": [{ fromVerse: 1, tone: "2.1" }],
    "4": [{ fromVerse: 1, tone: "8.1" }],
    "5": [{ fromVerse: 1, tone: "1a.4" }],
    "6": [{ fromVerse: 1, tone: "8.5" }],
    "7": [{ fromVerse: 1, tone: "1a.1" }],
    "8": [{ fromVerse: 1, tone: "5.2" }],
    "9": [{ fromVerse: 1, tone: "6a" }],
    "10": [{ fromVerse: 1, tone: "8.2" }],
    "11": [{ fromVerse: 1, tone: "5.2" }],
    "12": [{ fromVerse: 1, tone: "4.9" }],
    "13": [{ fromVerse: 1, tone: "3a.4" }],
    "14": [{ fromVerse: 1, tone: "7.4" }],
    "15": [{ fromVerse: 1, tone: "3a.5" }],
    "16": [{ fromVerse: 1, tone: "8.5" }],
    "17": [{ fromVerse: 1, tone: "7.6" }],
    "18": [
        { fromVerse: 1, tone: "1b.2" },
        { fromVerse: 21, tone: "2.1" },
        { fromVerse: 36, tone: "8.6" },
    ],
    "19": [{ fromVerse: 1, tone: "4.4" }],
    "20": [{ fromVerse: 1, tone: "3a.1" }],
    "21": [{ fromVerse: 1, tone: "8.2" }],
    "22": [
        { fromVerse: 1, tone: "2.1" },
        { fromVerse: 20, tone: "Tonus Peregrinus A" },
    ],
    "23": [{ fromVerse: 1, tone: "6a" }],
    "24": [{ fromVerse: 1, tone: "7.5" }],
    "25": [{ fromVerse: 1, tone: "1a.9" }],
    "26": [{ fromVerse: 1, tone: "6b" }],
    "27": [{ fromVerse: 1, tone: "7.3" }],
    "28": [{ fromVerse: 1, tone: "4.10" }],
    "29": [{ fromVerse: 1, tone: "5.3" }],
    "30": [{ fromVerse: 1, tone: "1b.10" }],
    "31": [
        { fromVerse: 1, tone: "8.1" },
        { fromVerse: 17, tone: "7.6" },
    ],
    "32": [{ fromVerse: 1, tone: "1a.8" }],
    "33": [{ fromVerse: 1, tone: "3a.5" }],
    "34": [{ fromVerse: 1, tone: "7.2" }],
    "35": [
        { fromVerse: 1, tone: "1a.1" },
        { fromVerse: 15, tone: "3a.6" },
    ],
    "36": [{ fromVerse: 1, tone: "2.1" }],
    "37": [
        { fromVerse: 1, tone: "1b.4" },
        { fromVerse: 12, tone: "1a.5" },
        { fromVerse: 25, tone: "7.5" },
    ],
    "38": [{ fromVerse: 1, tone: "4.8" }],
    "39": [{ fromVerse: 1, tone: "2.1" }],
    "40": [{ fromVerse: 1, tone: "6a" }],
    "41": [{ fromVerse: 1, tone: "3a.2" }],
    "42": [{ fromVerse: 1, tone: "5.1" }],
    "43": [{ fromVerse: 1, tone: "5.1" }],
    "44": [{ fromVerse: 1, tone: "4.7" }],
    "45": [{ fromVerse: 1, tone: "8.1" }],
    "46": [{ fromVerse: 1, tone: "5.3" }],
    "47": [{ fromVerse: 1, tone: "7.6" }],
    "48": [{ fromVerse: 1, tone: "1a.10" }],
    "49": [{ fromVerse: 1, tone: "2.1" }],
    "50": [{ fromVerse: 1, tone: "3a.2" }],
    "51": [{ fromVerse: 1, tone: "4.4" }],
    "52": [{ fromVerse: 1, tone: "7.7" }],
    "53": [{ fromVerse: 1, tone: "3a.5" }],
    "54": [{ fromVerse: 1, tone: "4.7" }],
    "55": [{ fromVerse: 1, tone: "1a.8" }],
    "56": [{ fromVerse: 1, tone: "1b.9" }],
    "57": [{ fromVerse: 1, tone: "8.6" }],
    "58": [{ fromVerse: 1, tone: "7.4" }],
    "59": [{ fromVerse: 1, tone: "4.7" }],
    "60": [{ fromVerse: 1, tone: "6a" }],
    "61": [{ fromVerse: 1, tone: "8.1" }],
    "62": [{ fromVerse: 1, tone: "4.10" }],
    "63": [{ fromVerse: 1, tone: "1a.10" }],
    "64": [{ fromVerse: 1, tone: "2.1" }],
    "65": [{ fromVerse: 1, tone: "7.5" }],
    "66": [{ fromVerse: 1, tone: "1b.3" }],
    "67": [{ fromVerse: 1, tone: "8.3" }],
    "68": [
        { fromVerse: 1, tone: "8.1" },
        { fromVerse: 19, tone: "7.4" },
    ],
    "69": [
        { fromVerse: 1, tone: "2.1" },
        { fromVerse: 19, tone: "1a.5" },
    ],
    "70": [{ fromVerse: 1, tone: "4.8" }],
    "71": [{ fromVerse: 1, tone: "4.9" }],
    "72": [{ fromVerse: 1, tone: "6a" }],
    "73": [
        { fromVerse: 1, tone: "7.5" },
        { fromVerse: 14, tone: "1b.8" },
    ],
    "74": [{ fromVerse: 1, tone: "2.1" }],
    "75": [{ fromVerse: 1, tone: "1a.3" }],
    "76": [{ fromVerse: 1, tone: "8.2" }],
    "77": [{ fromVerse: 1, tone: "2.1" }],
    "78": [
        { fromVerse: 1, tone: "1b.4" },
        { fromVerse: 19, tone: "4.7" },
        { fromVerse: 41, tone: "2.2" },
        { fromVerse: 57, tone: "Tonus Peregrinus A" },
    ],
    "79": [{ fromVerse: 1, tone: "7.1" }],
    "80": [{ fromVerse: 1, tone: "4.4" }],
    "81": [{ fromVerse: 1, tone: "3a.6" }],
    "82": [{ fromVerse: 1, tone: "8.2" }],
    "83": [{ fromVerse: 1, tone: "7.1" }],
    "84": [{ fromVerse: 1, tone: "3a.1" }],
    "85": [{ fromVerse: 1, tone: "4.4" }],
    "86": [{ fromVerse: 1, tone: "1b.4" }],
    "87": [{ fromVerse: 1, tone: "7.2" }],
    "88": [{ fromVerse: 1, tone: "4.7" }],
    "89": [
        { fromVerse: 1, tone: "1b.1" },
        { fromVerse: 19, tone: "5.3" },
        { fromVerse: 31, tone: "4.12" },
    ],
    "90": [{ fromVerse: 1, tone: "1a.2" }],
    "91": [{ fromVerse: 1, tone: "8.1" }],
    "92": [{ fromVerse: 1, tone: "6a" }],
    "93": [{ fromVerse: 1, tone: "5.3" }],
    "94": [{ fromVerse: 1, tone: "4.4" }],
    "95": [{ fromVerse: 1, tone: "3a.1" }],
    "96": [{ fromVerse: 1, tone: "8.1" }],
    "97": [{ fromVerse: 1, tone: "5.2" }],
    "98": [{ fromVerse: 1, tone: "6a" }],
    "99": [{ fromVerse: 1, tone: "4.4" }],
    "100": [{ fromVerse: 1, tone: "8.1" }],
    "101": [{ fromVerse: 1, tone: "7.5" }],
    "102": [
        { fromVerse: 1, tone: "1a.3" },
        { fromVerse: 15, tone: "7.1" },
    ],
    "103": [{ fromVerse: 1, tone: "5.3" }],
    "104": [
        { fromVerse: 1, tone: "3a.1" },
        { fromVerse: 24, tone: "4.7" },
    ],
    "105": [
        { fromVerse: 1, tone: "6b" },
        { fromVerse: 23, tone: "1a.7" },
    ],
    "106": [
        { fromVerse: 1, tone: "6a" },
        { fromVerse: 12, tone: "1a.8" },
    ],
    "107": [
        { fromVerse: 1, tone: "8.1" },
        { fromVerse: 23, tone: "1a.5" },
    ],
    "108": [{ fromVerse: 1, tone: "8.2" }],
    "109": [
        { fromVerse: 1, tone: "4.4" },
        { fromVerse: 12, tone: "4.7" },
    ],
    "110": [{ fromVerse: 1, tone: "3a.2" }],
    "111": [{ fromVerse: 1, tone: "4.7" }],
    "112": [{ fromVerse: 1, tone: "7.5" }],
    "113": [{ fromVerse: 1, tone: "5.2" }],
    "114": [{ fromVerse: 1, tone: "Tonus Peregrinus A" }],
    "115": [{ fromVerse: 1, tone: "Tonus Peregrinus A" }],
    "116": [{ fromVerse: 1, tone: "2.1" }],
    "117": [{ fromVerse: 1, tone: "Tonus Peregrinus A" }],
    "118": [
        { fromVerse: 1, tone: "1a.1" },
        { fromVerse: 15, tone: "Tonus Peregrinus A" },
    ],
    "119": [
        { fromVerse: 1, tone: "3a.4" },
        { fromVerse: 25, tone: "1a.12" },
        { fromVerse: 49, tone: "4.7" },
        { fromVerse: 73, tone: "1b.10" },
        { fromVerse: 89, tone: "2.1" },
        { fromVerse: 105, tone: "7.3" },
        { fromVerse: 129, tone: "5.1" },
        { fromVerse: 153, tone: "3a.4" },
    ],
    "120": [{ fromVerse: 1, tone: "1a.8" }],
    "121": [{ fromVerse: 1, tone: "1b.4" }],
    "122": [{ fromVerse: 1, tone: "4.7" }],
    "123": [{ fromVerse: 1, tone: "2.1" }],
    "124": [{ fromVerse: 1, tone: "7.7" }],
    "125": [{ fromVerse: 1, tone: "8.2" }],
    "126": [{ fromVerse: 1, tone: "1a.2" }],
    "127": [{ fromVerse: 1, tone: "2.1" }],
    "128": [{ fromVerse: 1, tone: "3a.5" }],
    "129": [{ fromVerse: 1, tone: "4.4" }],
    "130": [{ fromVerse: 1, tone: "4.7" }],
    "131": [{ fromVerse: 1, tone: "8.2" }],
    "132": [{ fromVerse: 1, tone: "6a" }],
    "133": [{ fromVerse: 1, tone: "8.3" }],
    "134": [{ fromVerse: 1, tone: "8.1" }],
    "135": [{ fromVerse: 1, tone: "7.2" }],
    "136": [
        { fromVerse: 1, tone: "3a.6" },
        { fromVerse: 15, tone: "1a.8" },
    ],
    "137": [{ fromVerse: 1, tone: "1a.9" }],
    "138": [{ fromVerse: 1, tone: "5.2" }],
    "139": [{ fromVerse: 1, tone: "1b.5" }],
    "140": [{ fromVerse: 1, tone: "3a.5" }],
    "141": [{ fromVerse: 1, tone: "8.6" }],
    "142": [{ fromVerse: 1, tone: "6b" }],
    "143": [{ fromVerse: 1, tone: "7.1" }],
    "144": [{ fromVerse: 1, tone: "1b.2" }],
    "145": [{ fromVerse: 1, tone: "5.1" }],
    "146": [{ fromVerse: 1, tone: "4.7" }],
    "147": [{ fromVerse: 1, tone: "8.1" }],
    "148": [{ fromVerse: 1, tone: "7.2" }],
    "149": [{ fromVerse: 1, tone: "6a" }],
    "150": [{ fromVerse: 1, tone: "Tonus Peregrinus A" }],
};
